module.exports = __webpack_public_path__ + "static/img/pic_bo.d4fdee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/pic_bo.png
// module id = 2big
// module chunks = 0